'use client';
import { FavoriteItem, FavoriteType } from "@/types/favorites";
import { apiSwagger } from "@/shared/api";

export const getFavoritesAction = async (
  userAccessToken: string | undefined,
  favoriteType?: FavoriteType
): Promise<FavoriteItem[]> => {
  if (!userAccessToken) {
    console.warn('No access token found. Returning empty favorites.');
    return [];
  }

  try {
    const response = await apiSwagger.samples.favoritesDetail(favoriteType);

    if (!response.ok) {
      const errorData = await response.json().catch(() => null);
      console.error('Failed to fetch favorites:', errorData?.msg || response.statusText);
      return [];
    }

    const data = await response.json();
    console.log('Favorites fetched successfully:', data.favorites);
    return data.favorites || [];
  } catch (err) {
    console.error('Error fetching favorites:', err);
    return [];
  }
};

export const addFavoriteAction = async (
  userAccessToken: string | undefined,
  favoriteId: string,
  favoriteType: FavoriteType
): Promise<Response | null> => {
  if (!userAccessToken) {
    console.warn('No access token found. Cannot add favorite.');
    return null;
  }

  try {
    const response = await apiSwagger.samples.favoritesCreate({
      id: favoriteId,
      type: favoriteType
    });


    if (!response.ok) {
      const errorData = await response.json().catch(() => null);
      console.error('Failed to add favorite:', errorData?.msg || response.statusText);
      return null;
    }

    return response;
  } catch (err) {
    console.error('Error adding favorite:', err);
    return null;
  }
};

export const deleteFavoriteAction = async (
  userAccessToken: string | undefined,
  favoriteId: string,
  favoriteType: FavoriteType
): Promise<Response | null> => {
  if (!userAccessToken) {
    console.warn('No access token found. Cannot delete favorite.');
    return null;
  }

  try {
    const response = await apiSwagger.samples.favoritesDelete(favoriteId, {type: favoriteType});

    if (!response.ok) {
      const errorData = await response.json().catch(() => null);
      console.error('Failed to delete favorite:', errorData?.msg || response.statusText);
      return null;
    }

    return response;
  } catch (err) {
    console.error('Error deleting favorite:', err);
    return null;
  }
};
